import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Megaphone } from 'lucide-react';
import { Button } from '@/shared/ui/Button';
import { EmptyState } from '@/shared/ui/EmptyState';
import type { StrategyDimension } from '../hooks/useAdsState';

const DESCRIPTIONS: Record<StrategyDimension, string> = {
  active:
    'No active campaigns for this location yet. New recommendations from your strategy will appear here once generated.',
  in_progress:
    'No active campaigns yet. Finish your strategy and PracticeNova will recommend campaigns tailored to your practice.',
  not_started:
    'No active campaigns yet. Create a marketing strategy and PracticeNova will recommend campaigns tailored to your practice.',
};

/**
 * Shown when an ad account is connected but there are no active / recommended /
 * in-draft campaigns. Shared by the Ads Overview and Campaigns pages so the copy
 * and CTA stay in sync. The CTA adapts to strategy progress; an active strategy
 * gets no CTA (recommendations arrive on their own).
 */
export function NoActiveCampaignsEmptyState({ strategy }: { strategy: StrategyDimension }) {
  const navigate = useNavigate();

  return (
    <EmptyState
      icon={<Megaphone size={40} strokeWidth={1.5} aria-hidden />}
      title="No active campaigns"
      description={DESCRIPTIONS[strategy]}
      actions={
        strategy === 'in_progress' ? (
          <Button variant="primary" onClick={() => navigate('/strategy')}>
            Complete strategy →
          </Button>
        ) : strategy === 'not_started' ? (
          <Button variant="primary" onClick={() => navigate('/strategy')}>
            Create marketing strategy →
          </Button>
        ) : undefined
      }
    />
  );
}
